import { useFormik } from "formik";
import React, { } from "react";
import { Button, Form } from "react-bootstrap";
import { Schema, object, string } from "yup";
import voresConfiguration from "../../client-configuration";
import { api } from "../../api";
import { SubscribeForm } from "../../lib-api";



const validationSchema: Schema<SubscribeForm> = object().shape({
    email: string().required(),
    name: string(),
    source: string()
});

export const ConfirmSubscriptionForm: React.FC<{ name: string; email: string; close: (confirmed: boolean) => void }> = ({ name, email, close }) => {

    const { handleSubmit, isSubmitting } = useFormik<SubscribeForm>({
        initialValues: {
            email: email,
            name: name,
            source: "Website-OneTap"
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            await api.subscribeToNewsletter(values, "one-tap");
            close(true);
        }
    })

    return (
        <Form onSubmit={handleSubmit}>
            <Form.Group>
                <p>
                    Hej {name}<br />
                    <br />
                    Du modtager fremover nyhedsbrevet for {voresConfiguration.site.name}. Nyhedsbrevet er gratis, og kan til enhver tid afmeldes.
                </p>
            </Form.Group>
            <Form.Group>
                <Form.Text className="font-weight-light">
                    Nyhedsbrevet kan indeholde tilbud fra lokale erhvervsdrivende, og partnere.&nbsp;
                    <a href="https://voresdigital.dk/privatlivspolitik/" target="_blank" className="text-primary" rel="noreferrer">Læs brugerbetingelser</a>
                </Form.Text>
            </Form.Group>
            <Form.Group className="d-flex justify-content-between mt-4">
                <Button className="mr-3" variant="outline-primary" onClick={() => close(false)}>
                    Afmeld
                </Button>
                <Button type="submit" disabled={isSubmitting} className="px-5">
                    OK
                </Button>
            </Form.Group>
        </Form>
    );
};
